module.exports = __webpack_public_path__ + "static/media/company.358f2d3b.png";